//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTrueFalse, formatTime } from '../../components/helpers.js'
import CardSeparator from '../../components/Card/CardSeparator.vue'
import DateTimeField from '../../components/Field/DateTimeField.vue'
import GeoPointField from '../../components/Field/GeoPointField.vue'
import FilesField from '../../components/File/FilesField.vue'
import Comments from '../../components/Comments/Comments.vue'

export default {
  components: {
    CardSeparator,
    DateTimeField,
    GeoPointField,
    Comments,
    FilesField
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    changes: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      formatTrueFalse: formatTrueFalse,
      formatTime: formatTime,

      filesGroupImagesBefore: null,
      filesGroupAttachmentBefore: null
    }
  },
  computed: {
    requestRoads: function () {
      return this.request.requestRoads
    }
  },
  methods: {
    getLabelColor: function (field) {
      if (this.changes.includes(field)) {
        return 'blue'
      } else {
        return 'black'
      }
    }
  }
}

